import React from 'react';
import Chip from '@material-ui/core/Chip';
import PropTypes from 'prop-types';
import { isMerchantRealm } from '../bruteForceStatusUi';

const userStyle = { backgroundColor: '#e3f2fd', color: '#0d47a1' };
const merchantStyle = { backgroundColor: '#ede7f6', color: '#4527a0' };

export default function BlacklistAccountTypeCell({ realm }) {
  const merchant = isMerchantRealm(realm);
  return (
    <div style={{ textAlign: 'center' }}>
      <Chip
        size="small"
        label={merchant ? 'Merchant user' : 'User'}
        style={merchant ? merchantStyle : userStyle}
      />
    </div>
  );
}

BlacklistAccountTypeCell.propTypes = {
  realm: PropTypes.string,
};
